
import React from "react";
import { useAuth } from "@/context/AuthContext";
import { useIsMobile } from "@/hooks/use-mobile";
import { 
  Sidebar, 
  SidebarContent, 
  SidebarFooter, 
  SidebarHeader, 
  SidebarMenu,
  SidebarGroup,
  SidebarGroupLabel,
  SidebarGroupContent,
  SidebarTrigger,
  useSidebar
} from "@/components/ui/sidebar";
import MenuItems from "./MenuItems";
import UserSection from "./UserSection";

const AppSidebar = () => {
  const { user } = useAuth();
  const isMobile = useIsMobile();
  const { isCollapsed } = useSidebar();

  return (
    <Sidebar>
      <SidebarHeader>
        <div className="flex justify-center">
          {isCollapsed || isMobile ? (
            <img 
              src="https://www.luijtenvvz.nl/wp-content/uploads/2025/02/LVVZ-Jubileum-RGB-webshop.svg" 
              alt="Luijten VVZ Logo" 
              className="h-8" 
            />
          ) : (
            <img 
              src="https://www.luijtenvvz.nl/wp-content/uploads/2025/02/LVVZ-Jubileum-RGB-webshop.svg" 
              alt="Luijten VVZ Logo" 
              className="h-[39px]" 
            />
          )}
        </div>
        {!isMobile && (
          <SidebarTrigger className="absolute right-2 top-4" />
        )}
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>{isMobile ? "Menu" : "Hoofdmenu"}</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {user && <MenuItems role={user.role} />}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
      <SidebarFooter className="border-t p-4">
        <UserSection />
      </SidebarFooter>
    </Sidebar>
  );
};

export default AppSidebar;
